import React from "react";
import Main from "../components/layout/Main";
import {QueryHistory} from "../components/query-builder/QueryHistory";
import {COHORT_ANALYSER_TITLE, QB_TITLE} from "./QueryBuilderPage";

interface QueryBuilderHistoryPageProps {
    isCohortAnalyser: boolean
}

export const QueryBuilderHistoryPage = ({isCohortAnalyser}: QueryBuilderHistoryPageProps) => {
    return <Main title={isCohortAnalyser ? COHORT_ANALYSER_TITLE : QB_TITLE}>
        <QueryHistory isCohortAnalyser={isCohortAnalyser}/>
    </Main>
}